/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { NatureFxWaterDropIcon16Light } from './NatureFxWaterDropIcon16Light';
import { NatureFxWaterDropIcon16Regular } from './NatureFxWaterDropIcon16Regular';
import { NatureFxWaterDropIcon16Solid } from './NatureFxWaterDropIcon16Solid';
import { NatureFxWaterDropIcon20Light } from './NatureFxWaterDropIcon20Light';
import { NatureFxWaterDropIcon20Regular } from './NatureFxWaterDropIcon20Regular';
import { NatureFxWaterDropIcon20Solid } from './NatureFxWaterDropIcon20Solid';
import { NatureFxWaterDropIcon24Regular } from './NatureFxWaterDropIcon24Regular';
import { NatureFxWaterDropIcon24Solid } from './NatureFxWaterDropIcon24Solid';
import { NatureFxWaterDropIcon32Regular } from './NatureFxWaterDropIcon32Regular';
import { NatureFxWaterDropIcon64Regular } from './NatureFxWaterDropIcon64Regular';
var sizes = {
    16: {
        light: NatureFxWaterDropIcon16Light,
        regular: NatureFxWaterDropIcon16Regular,
        solid: NatureFxWaterDropIcon16Solid,
    },
    20: {
        light: NatureFxWaterDropIcon20Light,
        regular: NatureFxWaterDropIcon20Regular,
        solid: NatureFxWaterDropIcon20Solid,
    },
    24: {
        regular: NatureFxWaterDropIcon24Regular,
        solid: NatureFxWaterDropIcon24Solid,
    },
    32: {
        regular: NatureFxWaterDropIcon32Regular,
    },
    64: {
        regular: NatureFxWaterDropIcon64Regular,
    },
};
export var NatureFxWaterDropIcon = forwardRef('NatureFxWaterDropIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
